// @flow

import type { Action } from './store.type';

export const AUTO_SETUP_THEME_REQUEST = 'AUTO_SETUP_THEME_REQUEST';
type AUTO_SETUP_THEME_REQUEST_TYPE = 'AUTO_SETUP_THEME_REQUEST';

export const AUTO_SETUP_THEME_SUCCESS = 'AUTO_SETUP_THEME_SUCCESS';
type AUTO_SETUP_THEME_SUCCESS_TYPE = 'AUTO_SETUP_THEME_SUCCESS';

export const AUTO_SETUP_THEME_FAILURE = 'AUTO_SETUP_THEME_FAILURE';
type AUTO_SETUP_THEME_FAILURE_TYPE = 'AUTO_SETUP_THEME_FAILURE';

export const SETUP_FEEDBACK_REQUEST = 'SETUP_FEEDBACK_REQUEST';
type SETUP_FEEDBACK_REQUEST_TYPE = 'SETUP_FEEDBACK_REQUEST';

export const SETUP_FEEDBACK_SUCCESS = 'SETUP_FEEDBACK_SUCCESS';
type SETUP_FEEDBACK_SUCCESS_TYPE = 'SETUP_FEEDBACK_SUCCESS';

export const SETUP_FEEDBACK_FAILURE = 'SETUP_FEEDBACK_FAILURE';
type SETUP_FEEDBACK_FAILURE_TYPE = 'SETUP_FEEDBACK_FAILURE';

export const RESET_SETUP_FEEDBACK = 'RESET_SETUP_FEEDBACK';
type RESET_SETUP_FEEDBACK_TYPE = 'RESET_SETUP_FEEDBACK';

export const GET_UPGRADE_THEME_STATUS_REQUEST = 'GET_UPGRADE_THEME_STATUS_REQUEST';
type GET_UPGRADE_THEME_STATUS_REQUEST_TYPE = 'GET_UPGRADE_THEME_STATUS_REQUEST';

export const GET_UPGRADE_THEME_STATUS_SUCCESS = 'GET_UPGRADE_THEME_STATUS_SUCCESS';
type GET_UPGRADE_THEME_STATUS_SUCCESS_TYPE = 'GET_UPGRADE_THEME_STATUS_SUCCESS';

export const GET_UPGRADE_THEME_STATUS_FAILURE = 'GET_UPGRADE_THEME_STATUS_FAILURE';
type GET_UPGRADE_THEME_STATUS_FAILURE_TYPE = 'GET_UPGRADE_THEME_STATUS_FAILURE';

export const RESET_UPGRADE_THEME_STATUS = 'RESET_UPGRADE_THEME_STATUS';
type RESET_UPGRADE_THEME_STATUS_TYPE = 'RESET_UPGRADE_THEME_STATUS';

type AutoSetupThemeSuccess = {
  data: {
    status: string,
    code: number
  }
};

type SetupFeedbackSuccess = {
  data: {
    status: string,
    code: number
  }
};

type GetUpgradeThemeStatusSuccess = {
  data: {
    duplicateTheme: number,
    installTheme: number
  }
};

type SetUpFailure = {
  error: any
};

type AutoSetupThemeRequestAction = Action<AUTO_SETUP_THEME_REQUEST_TYPE, null>;

type AutoSetupThemeSuccessAction = Action<AUTO_SETUP_THEME_SUCCESS_TYPE, AutoSetupThemeSuccess>;

type AutoSetupThemeFailureAction = Action<AUTO_SETUP_THEME_FAILURE_TYPE, SetUpFailure>;

type SetupFeedbackRequestAction = Action<SETUP_FEEDBACK_REQUEST_TYPE, null>;

type SetupFeedbackSuccessAction = Action<SETUP_FEEDBACK_SUCCESS_TYPE, SetupFeedbackSuccess>;

type SetupFeedbackFailureAction = Action<SETUP_FEEDBACK_FAILURE_TYPE, SetUpFailure>;

type ResetSetupFeedbackAction = Action<RESET_SETUP_FEEDBACK_TYPE, null>;

type GetUpgradeThemeStatusRequestAction = Action<GET_UPGRADE_THEME_STATUS_REQUEST_TYPE, null>;

type GetUpgradeThemeStatusSuccessAction = Action<
  GET_UPGRADE_THEME_STATUS_SUCCESS_TYPE,
  GetUpgradeThemeStatusSuccess
>;

type GetUpgradeThemeStatusFailureAction = Action<
  GET_UPGRADE_THEME_STATUS_FAILURE_TYPE,
  SetUpFailure
>;

type ResetUpgradeThemeStatusAction = Action<RESET_UPGRADE_THEME_STATUS_TYPE, {}>;

export type SetupAction =
  | AutoSetupThemeRequestAction
  | AutoSetupThemeSuccessAction
  | AutoSetupThemeFailureAction
  | SetupFeedbackRequestAction
  | SetupFeedbackSuccessAction
  | SetupFeedbackFailureAction
  | ResetSetupFeedbackAction
  | GetUpgradeThemeStatusRequestAction
  | GetUpgradeThemeStatusSuccessAction
  | GetUpgradeThemeStatusFailureAction
  | ResetUpgradeThemeStatusAction;

export type InstallState = {
  autoSetupThemeLoading: boolean,
  autoSetupThemeSuccess: boolean,
  setupFeedbackLoading: boolean,
  setupFeedbackSuccess: boolean,
  getUpgradeThemeStatusLoading: boolean,
  getUpgradeThemeStatusSuccess: boolean,
  error: any,
  code: number,
  status: string,
  progress: boolean
};
